module.exports = __webpack_public_path__ + "static/media/SarahSwitek_11_Questions-Conclusion_1.9439664e.mp3";